import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/sousuo.png';

const _withScopeId = n => (_pushScopeId("data-v-0341d22d"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "homebox clearfix"
};
const _hoisted_2 = {
  class: "owin-height"
};
const _hoisted_3 = {
  class: "notice-top"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, null, -1));

const _hoisted_5 = {
  class: "nav-list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "notice-total"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("找到");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("条相关结果");

const _hoisted_10 = {
  class: "notice-wrapper"
};
const _hoisted_11 = {
  class: "notice-list-wrapper"
};
const _hoisted_12 = {
  key: 0,
  class: "notice-list"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "second-left"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "second-right"
};
const _hoisted_17 = {
  class: "r_3"
};
const _hoisted_18 = ["title"];
const _hoisted_19 = ["title", "innerHTML"];
const _hoisted_20 = {
  class: "r_2"
};
const _hoisted_21 = {
  key: 1,
  class: "empty-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Head = _resolveComponent("Head");

  const _component_CommonTopTitle = _resolveComponent("CommonTopTitle");

  const _component_el_input = _resolveComponent("el-input");

  const _component_Empty = _resolveComponent("Empty");

  const _component_el_pagination = _resolveComponent("el-pagination");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Head, {
    menuInfo: $data.menuInfo,
    "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => $data.menuInfo = $event)
  }, null, 8, ["menuInfo"]), _createVNode(_component_CommonTopTitle, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.menuName), 1)]),
    _: 1
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("ul", _hoisted_5, [_createElementVNode("li", {
    onClick: _cache[1] || (_cache[1] = $event => $options.handleSearch()),
    class: _normalizeClass(["nav", !$data.pageInfo.newsTypeId && 'active'])
  }, " 全部 ", 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsTypeList, ({
    id,
    name
  }) => {
    return _openBlock(), _createElementBlock("li", {
      onClick: $event => $options.handleSearch(id),
      class: _normalizeClass(["nav", $data.pageInfo.newsTypeId === id && 'active']),
      key: id
    }, _toDisplayString(name), 11, _hoisted_6);
  }), 128))]), _createVNode(_component_el_input, {
    modelValue: $data.newsName,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.newsName = $event),
    size: "default",
    class: "search-input",
    onKeyup: _cache[4] || (_cache[4] = _withKeys($event => $options.handleSearch(), ["enter"])),
    placeholder: `搜索${$data.menuName}`
  }, {
    prefix: _withCtx(() => [_createElementVNode("img", {
      class: "search-icon",
      src: _imports_0,
      onClick: _cache[2] || (_cache[2] = (...args) => $options.handleSearch && $options.handleSearch(...args)),
      alt: ""
    })]),
    _: 1
  }, 8, ["modelValue", "placeholder"])]), _withDirectives(_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", null, _toDisplayString($data.pageInfo.rows), 1), _hoisted_9], 512), [[_vShow, $data.showSearchResult]]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [$data.newsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "second-style",
      key: item.id,
      onClick: $event => $options.showNewsDetail(item)
    }, [_createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
      width: "236",
      height: "144",
      src: item.cover_url || require('@/assets/images/video-cover.png'),
      alt: ""
    }, null, 8, _hoisted_15)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("span", {
      title: item.news_name
    }, _toDisplayString(item.news_name), 9, _hoisted_18)]), _createElementVNode("div", {
      class: "r_4",
      title: _ctx.$utils.getContentText(item.context),
      "data-html": "",
      innerHTML: _ctx.$utils.getContentText(item.context)
    }, null, 8, _hoisted_19), _createElementVNode("div", _hoisted_20, [_createElementVNode("span", null, _toDisplayString($options.dayjs(item.publish_time).format('YYYY.MM.DD')), 1)])])], 8, _hoisted_13);
  }), 128))])) : _createCommentVNode("", true), !$data.newsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_Empty, {
    text: "暂无数据"
  })])) : _createCommentVNode("", true), $data.pageInfo.rows && $data.pageInfo.rows > $data.pageInfo.pageLimit ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 2,
    class: "news-pagination",
    background: "",
    layout: "prev, pager, next",
    "prev-text": "上一页",
    "next-text": "下一页",
    onCurrentChange: $options.pageIndexChange,
    "current-page": $data.pageInfo.pageIndex,
    total: $data.pageInfo.rows,
    "page-size": $data.pageInfo.pageLimit
  }, null, 8, ["onCurrentChange", "current-page", "total", "page-size"])) : _createCommentVNode("", true)])])]), _createVNode(_component_Footer)]);
}